export default "__VITE_ASSET__DT$2kqCx__"